import styled from 'styled-components'
import { CircularProgress, Drawer as MUIDrawer } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;

  > span {
    font-size: 18px;
    font-weight: 600;
  }
`

const BodyContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-start;
  padding: 24px;
  overflow: auto;
`

const CustomHR = styled.hr`
  border: 1px solid #d6d7db;
`

const IconContainer = styled.div`
  cursor: pointer;
`

const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  justify-self: flex-end;
  padding: 24px;
`

const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

const DrawerBody = ({ loading, children }) => {
  return (
    <>
      {loading ? (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      ) : (
        <BodyContainer>{children}</BodyContainer>
      )}
    </>
  )
}

const DrawerActions = ({ children }) => {
  return (
    <>
      <CustomHR />
      <ActionsContainer>{children}</ActionsContainer>
    </>
  )
}

const Drawer = ({ title, open, onClose, children }) => {
  return (
    <MUIDrawer
      open={open}
      onClose={onClose}
      anchor='right'
      transitionDuration={300}
      PaperProps={{
        sx: { width: 420 },
      }}
    >
      <Container>
        <HeaderContainer>
          <span>{title}</span>
          <IconContainer onClick={onClose}>
            <CloseIcon />
          </IconContainer>
        </HeaderContainer>
        <CustomHR />
        {children}
      </Container>
    </MUIDrawer>
  )
}

Drawer.Body = DrawerBody
Drawer.Actions = DrawerActions

export default Drawer
